import i18next from 'i18next';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../../../../constants';
import { localStorageService } from '../services/service-factory';
// VeeValidate
import { localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import de from 'vee-validate/dist/locale/de.json';

localize({
  en,
  de
});

const translate = function(key, params) {
  return params ? i18next.t(key, params) : i18next.t(key);
};

export default {
  install(Vue, options) {
    this.lng = options.lng || localStorageService.get('lng') || DEFAULT_LANGUAGE;
    i18next.init({
      lng: this.lng,
      // debug: process.env.NODE_ENV === 'development',
      debug: false,
      nsSeparator: false,
      resources: options.resources
    });

    localize(this.lng);
    localStorageService.set('lng', this.lng);

    Vue.filter('i18n', function(key, params) {
      return i18next.t(key, params);
    });

    Vue.prototype.$translate = translate;

    Vue.prototype.$changeLanguage = function(language) {
      if (SUPPORTED_LANGUAGES.indexOf(language) === -1) {
        throw new Error('Language is not supported.');
      }

      if (language === this.lng) {
        return;
      }

      i18next
        .changeLanguage(language)
        .then(() => {
          localize(language);
          localStorageService.set('lng', language);
          Vue.prototype.$lng = language;
          this.$router.go();
        })
        .catch(err => {
          console.log(err);
        });
    };

    Vue.prototype.$lng = this.lng;

    Vue.mixin({
      data: () => {
        return {
          lng: this.lng
        };
      }
    });
  },
  translate
};
